require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/fn/get-iterator.js
// module id = 1147
// module chunks = 168707334958949